import React, { useState, useEffect } from 'react';
import {
  FlexBox,
  FlexBoxHorizontal,
  TextField,
} from '../../atoms';
import {
  SearchButton,
  SelectAllCheckBox,
} from '../../molecules';
import { Filter } from '../../organisms';


const CadDataFilter = ({ data, onSearch }) => {
  const filterOptions = {
    ...data,
    searchValue: null,
  };
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    // filterOptions가 업데이트된 후 sesn의 첫 번째 옵션을 자동으로 선택하고 onSearch 호출
    const newSelectedOptions = {
      ...filterOptions,
      sesn: filterOptions.sesn && filterOptions.sesn[0] ? [{ value: '27F', label: '27F' }] : [], // 첫 번째 sesn 옵션 선택
    };

    setSelectedOptions(newSelectedOptions);
    onSearch(newSelectedOptions);  // 선택된 옵션을 onSearch에 전달
  }, [data]); // data가 변경될 때마다 호출


  const handleSelectedOptions = (key, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [key]: value,
    }));
    onSearch({ ...selectedOptions, [key]: value });
  };

  return (
    <Filter style={{ height: '60px', flexDirection: 'column' }}>
      <FlexBoxHorizontal style={{ justifyContent: 'space-between', overflow: 'auto' }}>
        <FlexBox>
          {data.parentPrdtKind.length > 0 ? <>
            <div
              style={{
                width: '170px',
                margin: '0 10px 0 20px',
              }}

            >
              <SelectAllCheckBox
                selected={selectedOptions.sesn}
                setSelected={(value) => handleSelectedOptions('sesn', value)}
                options={filterOptions.sesn}
                title={'시즌'}
                allSelectTitle="시즌 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '160px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.parentPrdtKind}
                setSelected={(value) => handleSelectedOptions('parentPrdtKind', value)}
                options={filterOptions.parentPrdtKind}
                title={'대분류'}
                allSelectTitle="대분류 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '160px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.prdtKind}
                setSelected={(value) => handleSelectedOptions('prdtKind', value)}
                options={filterOptions.prdtKind}
                title={'중분류'}
                allSelectTitle="중분류 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '160px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.item}
                setSelected={(value) => handleSelectedOptions('item', value)}
                options={filterOptions.item}
                title={'아이템'}
                allSelectTitle="아이템 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '210px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.lifeStyle}
                setSelected={(value) => handleSelectedOptions('lifeStyle', value)}
                options={filterOptions.lifeStyle}
                title={'IMC'}
                allSelectTitle="IMC All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '170px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.designer}
                setSelected={(value) => handleSelectedOptions('designer', value)}
                options={filterOptions.designer}
                title={'디자이너'}
                allSelectTitle="디자이너 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '170px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.fabric}
                setSelected={(value) => handleSelectedOptions('fabric', value)}
                options={filterOptions.fabric}
                title={'패브릭'}
                allSelectTitle="패브릭 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '170px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.vendor}
                setSelected={(value) => handleSelectedOptions('vendor', value)}
                options={filterOptions.vendor}
                title={'협력사'}
                allSelectTitle="협력사 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '170px',
                marginRight: '10px',
              }}
            >
              <SelectAllCheckBox
                selected={selectedOptions.graphic}
                setSelected={(value) => handleSelectedOptions('graphic', value)}
                options={filterOptions.graphic}
                title={'그래픽 코드'}
                allSelectTitle="그래픽 코드 All"
                isMulti
              />
            </div>
            <div
              style={{
                width: '170px',
                marginRight: '10px',
              }}
            >
              <TextField
                placeholder="품번/제품명/컬러"
                onChange={(value) => handleSelectedOptions('searchValue', value)}
              />
            </div></> : null}
        </FlexBox>
        <FlexBox>
          {/* <SearchButton
            label={'검색'}
            style={{ minWidth: '70px', marginRight: '20px' }}
            onClick={() => onSearch(selectedOptions)}
          /> */}
        </FlexBox>
      </FlexBoxHorizontal>
    </Filter>
  );
};

export default CadDataFilter;

